
  import * as netlifyRuntime$NgrbMJorhFeDAz13TitYjDN5JV_zK31aq3xJBFXavpg from '/opt/build/repo/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@8.2.0_@parcel+watcher@2.6.0_db0@0.3.4_ioredis@5.11.1_magicast@0.5.5_srvx@0.11.22/node_modules/@nuxt/image/dist/runtime/providers/netlifyImageCdn'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "netlify",
  "domains": [
    "images.prismic.io",
    "prismic.io"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['netlify']: { provider: netlifyRuntime$NgrbMJorhFeDAz13TitYjDN5JV_zK31aq3xJBFXavpg, defaults: {} }
    }
  }
